import { TooltipRenderProps } from 'react-joyride';
import { t } from 'locale';

import { Button } from 'components/_V2/Button/Button';

import { localeKeys } from 'enums/localeKeys';

export const ProductOnboardingTooltip = (props: TooltipRenderProps) => {
  const { continuous, index, primaryProps, skipProps, step, tooltipProps, size, isLastStep } =
    props;

  return (
    <div
      className="flex max-w-[280px] flex-col gap-y-2 rounded bg-white p-4 dark:bg-general-80 md:max-w-[350px]"
      {...tooltipProps}
    >
      <span
        className="text-body-smaller-bold text-general-80"
        data-testid="product-onboarding-tooltip-steps"
      >
        {index + 1} / {size}
      </span>
      {step.title && (
        <span className="subtitle-2" data-testid="product-onboarding-tooltip-step-title">
          {step.title}
        </span>
      )}
      <div>{step.content}</div>
      {isLastStep ? (
        <Button
          variant="secondary"
          className="flex max-w-[50%] justify-center"
          {...skipProps}
          data-testid="product-onboarding-tooltip-done-button"
        >
          {t(localeKeys.done)}
        </Button>
      ) : (
        <div className="flex gap-x-2">
          {continuous && (
            <Button
              variant="secondary"
              className="flex justify-center"
              {...primaryProps}
              data-testid="product-onboarding-tooltip-next-tip-button"
            >
              {t(localeKeys.productOnboardingNextTip)}
            </Button>
          )}
          <Button
            variant="tertiary"
            className="flex justify-center"
            {...skipProps}
            data-testid="product-onboarding-tooltip-cancel-button"
          >
            {t(localeKeys.productOnboardingCancel)}
          </Button>
        </div>
      )}
    </div>
  );
};
